import React from 'react'
import Page from 'contexts/page'
import { useAccess } from 'contexts/access'
import paths from 'app/paths'
import { Navigate } from 'react-router-dom'
import Routing from './routing'

const CorporationPage = ({ upgradable }) => {
    const { check } = useAccess()
    const corporationAdmin = check('subsidiaries:manage')

    if(!corporationAdmin) {
        return <Navigate to={paths.root} replace />
    }

    return (
        <Page
            view="corporation"
            title={{
                id: 'noun_corporation',
                defaultMessage: 'Corporation'
            }}
            upgrade={{
                enabled: upgradable,
                passthrough: true
            }}>
            <Routing />
        </Page>
    )
}

export default CorporationPage